export default __webpack_public_path__ + "static/media/4.478ee104.jpeg";